const $wholeDayCheckbox = $('#event-proposal-isWholeDay')
const $timeInputs = $('#event-proposal-startTime,#event-proposal-endTime')

$wholeDayCheckbox.on('change', (event) => {
    if ($wholeDayCheckbox.is(':checked')) {
        $timeInputs.hide()
    } else {
        $timeInputs.show()
    }
})
